import { gql } from "@apollo/client";

export const listSweepstakesActive = gql`
  query ListSweepstakesLatest($filter: SweepstakesListFilter = {}) {
    listSweepstakesLatest(filter: $filter) {
      total
      items {
        id
        title
        description
        status
        startsAt
        endsAt
        sweepNumberType
        approvalMode
        winnersRequired
        maxWinsPerUser
        numberLength
        maxEntriesPerUser
        timezone
        numberMin
        numberMax
        count
        zeroPad
        createdAt
        updatedAt
        entrantCount
      }
    }
  }
`;
export const getSweepstakes = gql`
  query GetSweepstakes($id: ID!) {
    getSweepstakes(id: $id) {
      id
      title
      description
      status
      startsAt
      endsAt
      sweepNumberType
      approvalMode
      createdAt
      updatedAt
    }
  }
`;
